import { LAYERADD } from "../../actions/portal/";

export default function(state = null, action){
  switch (action.type) {
    case LAYERADD:
    return action.payload;
    default:
  }

  return state;
}
